<template>
  <div class="cell-inner table-mod-links">
    <span v-if="!hasLinks">-</span>

    <div v-else class="table-mod-links__list gap-8">
      <router-link
        v-for="(item, index) of data"
        :key="item.id"
        class="table-mod-links__item link"
        :to="getRouteHandler(item)"
        v-text="index !== data.length-1 ? item.text + ',' : item.text"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableModLinks',
  props: {
    data: {
      type: Array // { text: string, id: number }[]
    },
    getRouteHandler: {
      type: Function, // (item) => { name: string, params: { ... } }
      required: true
    }
  },

  computed: {
    hasLinks () {
      return this.data?.length
    }
  }
}
</script>

<style lang="scss">
.table-mod-links {
  &__list {
    display: flex;
    flex-wrap: wrap;
    width: max-content;
    max-width: 300px;
  }

  &__item {
    white-space: nowrap;
  }
}
</style>
